<div id="pre-config-form">

    <div class="ui-grid-row">
      <div class="ui-grid-col-12">
        <p-messages [(value)]="messages"></p-messages>
      </div>
    </div>
  
    <p-panel header="SC350M Parameters">
        <div class="ui-g" *ngIf=isConfig style="margin-bottom:20px">
          <div class="ui-g-12 ui-md-6">
        
            <div class="col row dvcFields">
              <div class="col lblStyle">
                <form-input i18n-fieldName fieldName="load preconfig" [errors]="errors.preConfig">
                </form-input>
              </div>
              <div class="col">
                <p-dropdown (onChange)="loadPreconfig($event)" i18n-placeholder placeholder="Select" editable="editable"
                  [options]="availablePreconfigs" [(ngModel)]="selectedPreconfig" [style]="{'width':'100%','min-width':'100px'}"
                  filter="filter"></p-dropdown>
              </div>
            </div>
        
          </div>
        </div>
  
      <p-tabView #tv (onChange)="tabChanged()">
        <p-tabPanel header="Events">
          <p-accordion [multiple]="true" [style]="{'margin-top':'10px'}" #ac>
              <app-accelerometer-virtual-ignition-settings-sc350m [(avsParameters)]="deviceParams.proprietaryParameters.avsParameters"></app-accelerometer-virtual-ignition-settings-sc350m>
              <app-bearer-setting-information-sc350m [(bsiParameters)]="deviceParams.proprietaryParameters.bsiParameters"></app-bearer-setting-information-sc350m>
              <app-binding-sim-card-sc350m [(simParameters)]="deviceParams.proprietaryParameters.simParameters"></app-binding-sim-card-sc350m>
              <app-buzzer-alarm-sc350m [(bzaParameters)]="deviceParams.proprietaryParameters.bzaParameters"></app-buzzer-alarm-sc350m>
              <app-default-assist-level-sc350m [(aslParameters)]="deviceParams.proprietaryParameters.aslParameters"></app-default-assist-level-sc350m>
              <app-ecu-configuration-sc350m [(ecuParameters)]="deviceParams.proprietaryParameters.ecuParameters"></app-ecu-configuration-sc350m>
              <app-ecu-message-configuration-sc350m [(ecmParameters)]="deviceParams.proprietaryParameters.ecmParameters"></app-ecu-message-configuration-sc350m>
              <app-excessive-idling-detection-sc350m [(idlParameters)]="deviceParams.proprietaryParameters.idlParameters"></app-excessive-idling-detection-sc350m>
              <app-external-power-supply-sc350m [(epsParameters)]="deviceParams.proprietaryParameters.epsParameters"></app-external-power-supply-sc350m>
              <app-fixed-report-information-sc350m [(friParameters)]="deviceParams.proprietaryParameters.friParameters"></app-fixed-report-information-sc350m>
              <app-geo-fence-parameters-sc350m [(geoParameters)]="deviceParams.proprietaryParameters.geoParameters"></app-geo-fence-parameters-sc350m>
              <app-global-parameters-sc350m [(globalParameters)]="deviceParams.proprietaryParameters.globalParameters"></app-global-parameters-sc350m>
              <app-gnss-assisted-motion-measurement-sc350m [(gamParameters)]="deviceParams.proprietaryParameters.gamParameters"></app-gnss-assisted-motion-measurement-sc350m>
              <app-hour-meter-count-sc350m [(hmcParameters)]="deviceParams.proprietaryParameters.hmcParameters"></app-hour-meter-count-sc350m>
              <app-ignition-detection-sc350m [(igdParameters)]="deviceParams.proprietaryParameters.igdParameters"></app-ignition-detection-sc350m>
              <app-max-assist-level-sc350m [(limParameters)]="deviceParams.proprietaryParameters.limParameters"></app-max-assist-level-sc350m>
              <app-outside-working-hours-sc350m [(owhParameters)]="deviceParams.proprietaryParameters.owhParameters"></app-outside-working-hours-sc350m>
              <app-overspeed-alarm-sc350m [(spaParameters)]="deviceParams.proprietaryParameters.spaParameters"></app-overspeed-alarm-sc350m>
              <app-polygon-geo-fence-parameters-sc350m [(peoParameters)]="deviceParams.proprietaryParameters.peoParameters"></app-polygon-geo-fence-parameters-sc350m>
              <app-preserving-device-logic-states-sc350m [(pdsParameters)]="deviceParams.proprietaryParameters.pdsParameters"></app-preserving-device-logic-states-sc350m>
              <app-protocol-watchdog-sc350m [(dogParameters)]="deviceParams.proprietaryParameters.dogParameters"></app-protocol-watchdog-sc350m>
              <app-roaming-detection-sc350m [(rmdParameters)]="deviceParams.proprietaryParameters.rmdParameters"></app-roaming-detection-sc350m>
              <app-server-registration-information-sc350m [(sriParameters)]="deviceParams.proprietaryParameters.sriParameters"></app-server-registration-information-sc350m>
              <app-start-stop-report-sc350m [(ssrParameters)]="deviceParams.proprietaryParameters.ssrParameters"></app-start-stop-report-sc350m>
              <app-tow-alarm-sc350m [(towParameters)]="deviceParams.proprietaryParameters.towParameters"></app-tow-alarm-sc350m>
              <app-unlock-pin-sc350m [(pinParameters)]="deviceParams.proprietaryParameters.pinParameters"></app-unlock-pin-sc350m>
              <app-update-device-parameters-sc350m [(upcParameters)]="deviceParams.proprietaryParameters.upcParameters"></app-update-device-parameters-sc350m>

            </p-accordion>
        </p-tabPanel>
  
        <p-tabPanel  header="Sensors">
          <app-sensor-list [(sensors)]="deviceParams.sensors"></app-sensor-list>
          <!-- Sensors list -->
        </p-tabPanel>
        <p-tabPanel i18n-header header="Actuators">
            <app-actuators-list [(actuators)]="deviceParams.actuators"></app-actuators-list>
        </p-tabPanel>
  
      </p-tabView>
    </p-panel>
    <p-confirmDialog  header="Confirmation" icon="fa fa-question-circle" width="425"></p-confirmDialog>
  </div>
  